import FeedbackForm from "../../components/feedback/FeedbackForm.tsx";
import { useTeacherQuery } from "../../api/teacherApi.ts";
import { useParams } from "react-router";

function FeedbackPage() {
  const { teacherId } = useParams();
  const { data: teacher } = useTeacherQuery(teacherId);

  if (!teacherId) {
    return <span>No teacherId present</span>;
  }

  return (
    <div className={"mt-8"}>
      <FeedbackForm
        teacherId={teacherId}
        firstName={teacher?.firstName}
        lastName={teacher?.lastName}
        profilePicture={teacher?.profilePictureUrl}
      />
    </div>
  );
}

export default FeedbackPage;
